module.exports = __webpack_public_path__ + "img/w26-cover.bb9aae2e.jpg";